<div
[style.BackgroundColor]='backgroundColor'
[style.Color]='foregroundColor'
[style.Padding]="'4px 16px'"
[style.BorderRadius]="'8px'"
[style.fontWeight]="'600'"
[style.display]="'inline-block'"
[style.width]="'100%'"
>
<span>{{ text }}</span> 
</div>